import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateLoader, TranslateService } from "@ngx-translate/core";
import { featureServiceInjectionToken, IFeatureService } from "moo-shared";
import { tap } from "rxjs";
import { HttpErrorHandlerService } from "./core/http-response-interceptor.service";
import { BaseComponent } from "./shared/base.component";
import { NotificationBarComponent } from "./shared/notification-bar";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent extends BaseComponent implements OnInit, AfterViewInit {
  override componentTranslationRoot = "app";
  private multiLanguageEnabled = true;
  private language: string | undefined = "nl";

  @ViewChild("notificationBar", { static: false }) notificationBar!: NotificationBarComponent;
  constructor(translateService: TranslateService,
    private titleService: Title,
    private translationDictionaryLoader: TranslateLoader,
    private httpErrorHandlerService: HttpErrorHandlerService,
    @Inject(featureServiceInjectionToken) private readonly featureService: IFeatureService,
    @Inject(DOCUMENT) private readonly document: any
  ) {
    super(translateService);

    this.translateService.addLangs(["nl", "de"]);

    this.featureService.get("StartPortal.MultiLanguage", false).pipe(
      tap(x => {
        this.multiLanguageEnabled = x;
        if (this.multiLanguageEnabled) {
          const browserLanguage = this.translateService.getBrowserLang();
          this.language = this.translateService.langs.some(y => y === browserLanguage) ? browserLanguage : "nl";
        }
      })).subscribe();

    this.translationDictionaryLoader.getTranslation(this.language!).subscribe((data) => {
      this.translateService.setTranslation(this.language!, data);
      this.titleService.setTitle(this.translate("app-title"));
    });
  }

  ngOnInit(): void {
    if (this.multiLanguageEnabled) {
      this.translateService.use(this.language!);
    }
  }

  ngAfterViewInit(): void {
    this.httpErrorHandlerService.notificationBar = this.notificationBar;
  }

  
}
